import { useState } from 'react';
import PopoverMui, { PopoverOrigin } from '@mui/material/Popover';
import Button from '@mui/material/Button';

interface PopoverProps {
  buttonText: string | React.ReactElement;
  children: React.ReactElement;
  anchorOrigin?: PopoverOrigin | undefined;
  transformOrigin?: PopoverOrigin | undefined;
  buttonId?: string;
  buttonStyle?: { [key: string]: string | { [key: string]: string } };
}

export const Popover = ({
  buttonText,
  children,
  anchorOrigin,
  transformOrigin,
  buttonId,
  buttonStyle,
}: PopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? buttonId : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        sx={{
          height: '27px',
          backgroundColor: '#38A7B4',
          fontFamily: 'Tajawal !important',
          '&:hover': {
            backgroundColor: '#38A7B4',
            opacity: '70%',
          },
          ...buttonStyle,
        }}
      >
        {buttonText}
      </Button>
      <PopoverMui
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin || {
            vertical: 'bottom',
            horizontal: 'left',
          }
        }
        transformOrigin={
          transformOrigin || {
            vertical: 'top',
            horizontal: 'left',
          }
        }
        sx={{ '& .MuiTypography-root': { fontFamily: 'Tajawal !important' } }}
      >
        {children}
      </PopoverMui>
    </div>
  );
};
